import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { addonsFetcher } from '../../fetchers/batches-fetcher';

type Props = {
  data: Addon[];
  isLoading: boolean;
};
export const ADD_ONS_QUERY_KEY = (batchSlug: string) => 'batch-add-ons-' + batchSlug;
const useAddons = ({ batchSlug, enabled }: { enabled?: boolean; batchSlug: string }): Props => {
  const { data, isLoading } = useQuery(
    [
      ADD_ONS_QUERY_KEY(batchSlug),
      {
        batchId: batchSlug,
        params: {
          type: 'KHAZANA,SAARTHI',
          fields: 'type,typeId',
        },
      },
    ],
    addonsFetcher,
    {
      retry: false,
      refetchOnWindowFocus: false,
      enabled: enabled !== false && !!batchSlug,
      staleTime: 1000 * 60 * 60,
    },
  );

  const Data = useMemo(() => {
    const list: Addon[] = [];
    if (Array.isArray(data?.data)) {
      data?.data.forEach((element: any) => {
        list.push(new Addon(element));
      });
    }
    return list;
  }, [data]);
  return {
    data: Data,
    isLoading,
  };
};

class Addon {
  _id: string;
  type: string;
  typeId: string;
  constructor(data: any) {
    data = data || {};
    this._id = data?._id || '';
    this.type = data?.type || '';
    this.typeId = data?.typeId || '';
  }
}

export default useAddons;
